import API_BACK from "../lib/axiosBack";
// import API from "../lib/axios";
import { RateResponse } from "../types/rate";
import { logoutCompletely } from "../utils/logoutCompletely";

export const getExchangeRate = async (
  crypto: string,
  fiat: string
): Promise<number> => {
  const token = localStorage.getItem("accessToken");

  try {
    const response = await API_BACK.get<RateResponse>("/rate", {
      // const response = await API.get<RateResponse>("/back/rate", {
      params: {
        cryptoCurrency: crypto,
        fiatCurrency: fiat,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data?.rate;
  } catch (error: any) {
    const status = error?.response?.status;

    if (status === 401) {
      console.warn("🔒 User not authenticated (401)");
      logoutCompletely();
    } else if (status === 404) {
      console.error("❌ Exchange rate not found (404)");
    } else if (status === 500) {
      console.error("💥 Internal server error (500)");
    } else {
      console.error(
        "❌ Unknown error occurred while fetching exchange rate:",
        error
      );
    }

    throw error;
  }
};
